import React from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import { IconButton } from '@mui/material';

import { ParagonHeader } from '@paragon/material';
import { UserDropdown } from '@paragon/themes';

import reviewLogoUrl from '../../../resources/review.png';
import { loadJobs } from '../../actions/loadActions';
import { setActiveControl } from '../../store/jobsSlice';
import { useAppDispatch, useAppSelector } from '../hooks';

export default function Header() {
  const dispatch = useAppDispatch();
  const isInsertingJob = useAppSelector((state) => state.statuses.isInsertingJob);
  const isLoadingJobs = useAppSelector((state) => state.statuses.isLoadingJobs);
  const isLoadingPdfsForMerging = useAppSelector((state) => state.statuses.isLoadingPdfsForMerging);

  const onRefreshJobs = () => {
    dispatch(setActiveControl(null));
    dispatch(loadJobs());
  };

  return (
    <ParagonHeader
      text="Paragon Review"
      clientLogoUrl={reviewLogoUrl}
      clientName="Paragon Review"
      forceSpinner={isLoadingJobs || isInsertingJob || isLoadingPdfsForMerging}
    >
      <UserDropdown sx={{ color: 'appBar.text' }} />
      <IconButton sx={{ color: 'appBar.text' }} title="Refresh" onClick={onRefreshJobs} key="refresh">
        <RefreshIcon />
      </IconButton>
    </ParagonHeader>
  );
}
